<template>
  <div id="app">
    <Head v-show="$route.meta.show"></Head>
    <router-view/>
    <Food v-show="$route.meta.show"></Food>
  </div>
</template>

<script>
import Head from '@/components/Head'
import Food from '@/components/Food'
import {
  IsLogin
} from "@/api/general-api"
import { getToken } from "@/utils/myAuth";

export default {
  name: 'app',
  components: {
    Food,
    Head
  },
  data() {
    return {
     PhoneNo:13177898738
    }
  },
  computed: {
  
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
		"$route": "getIndex"
  },
  methods:{
    getIndex(){
      if('loginpage,forgetpage,enrollpage'.indexOf(this.$route.name)<0){
        const token = getToken()
        if (token){
          IsLogin(token).then(res=>{
            if(!res.success){
              this.$router.push("/login?url=" + this.$route.path)
            }
          })
        }else{
          this.$router.push("/login?url=" + this.$route.path)
        }
      }
    }
  }
}
</script>


<style lang="scss">


</style>
